import React from 'react';
import LocationTemplate from './LocationTemplate';

const SimsPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Sims"
      stateName="North Carolina"
      countyName="Wilson"
      zipCodes={["27880"]}
      latitude={35.761}
      longitude={-78.075}
      population={280}
      historicalFact="Named after local landowner George Thomas Sims; incorporated in 1913."
      nearbyTowns={[
        "Wilson, NC",
        "Nashville, NC",
        "Rocky Mount, NC",
        "Elm City, NC",
        "Middlesex, NC",
        "Bailey, NC",
        "Lucama, NC",
        "Black Creek, NC"
      ]}
    />
  );
};

export default SimsPage;